import React from "react";
import PropTypes from "prop-types";
import Beaker from "./img/Beaker.svg";

const cellRef = React.createRef();

export function LabelCell(props) {
  const [ariaLabel, setAriaLabel] = React.useState();

  React.useEffect(() => {
    {
      props.headingAriaLabel
        ? renderAriaLabel(props.headingAriaLabel, props.label)
        : null;
    }
  }, [JSON.stringify(props.headingAriaLabel)]);

  const renderAriaLabel = (headingAriaLabel, cellLabel) => {
    if (headingAriaLabel.length !== 0) {
      headingAriaLabel.map((list) => {
        if (list.label === cellLabel) {
          function renderAirialabel() {
            if (typeof list.ariaLabel === "object") {
              if (list.ariaLabel.dialysisBand2 === undefined) {
                const ariaLabel = `"Lane ${cellLabel}, ${list.ariaLabel.dialysisBand1}`;
                return ariaLabel;
              } else {
                const ariaLabel = `Lane ${cellLabel}, ${list.ariaLabel.dialysisBand1},${list.ariaLabel.dialysisBand2}`;
                return ariaLabel;
              }
            } else {
              const ariaLabel = `Lane ${cellLabel}, ${list.ariaLabel}`;
              return ariaLabel;
            }
          }
          return setAriaLabel(renderAirialabel);
        }
      });
    } else {
      return null;
    }
  };

  return (
    <div
      ref={cellRef}
      className={props.className}
      tabIndex={props.tabIndex}
      aria-label={ariaLabel}
    >
      <img src={Beaker} alt="" />
      <p className={`${props.className}__label`}>{props.label}</p>
    </div>
  );
}

LabelCell.propTypes = {
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * Label to dispaly on the cel
   */
  label: PropTypes.string,
  /**
   * AriaLabel of the heading
   */
  headingAriaLabel: PropTypes.shape({
    /**
     * Unique key for the data
     */
    key: PropTypes.number,
    /**
     * Label of the Heading
     */
    label: PropTypes.string,
    /**
     * Arialabel to display on the heading
     */
    ariaLabel: PropTypes.string,
    /**
     * Tabindex value passed from outside the component for keyboard navigation
     */
    tabIndex: PropTypes.number,
  }),
};

LabelCell.defaultProps = { tabIndex: 0 };
